'use client';

import { HStack } from '@terra/ui-styled-system';
import { Text } from '../../../../../components/styled/text';
import { BadgeHttp } from '../../../../../components/styled/badge-http';
import { Tick01Icon, Globe02Icon, Link02Icon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';
import type { ParsedEndpoint } from '../../ToolCallsRenderers/types';

export type EndpointListItemProps = {
  endpoint: ParsedEndpoint;
  isSelected: boolean;
  onSelect: (ep: ParsedEndpoint) => void;
};
export function EndpointListItem({
  endpoint,
  isSelected,
  onSelect,
}: EndpointListItemProps) {
  const t = useTranslations('designSystem.chat.updateSignalModal');
  const displayPath = endpoint.path || endpoint.endpointUrl;
  const displayText =
    displayPath ||
    endpoint.endpointDescription ||
    endpoint.endpointId ||
    t('fields.endpoint');

  return (
    <HStack
      gap={2}
      alignItems="center"
      py={1.5}
      px={2}
      borderRadius="sm"
      cursor="pointer"
      bg={isSelected ? 'bg.muted' : 'transparent'}
      borderWidth="1px"
      borderColor={isSelected ? 'border.default' : 'transparent'}
      _hover={{ bg: 'bg.muted' }}
      onClick={() => onSelect(endpoint)}
      width="100%"
      minWidth={0}
      userSelect="none"
    >
      {endpoint.method ? (
        <BadgeHttp
          method={endpoint.method}
          size="sm"
          variant="emphasis"
          flexShrink={0}
          fontWeight="normal"
        >
          {endpoint.method}
        </BadgeHttp>
      ) : null}

      <HStack gap={1} alignItems="center" flex={1} minWidth={0}>
        {displayPath ? (
          <Link02Icon
            size={10}
            style={{ flexShrink: 0, color: 'var(--colors-fg-subtle)' }}
          />
        ) : (
          <Globe02Icon
            size={10}
            style={{ flexShrink: 0, color: 'var(--colors-fg-subtle)' }}
          />
        )}
        <Text
          fontSize="xs"
          fontFamily={displayPath ? 'mono' : undefined}
          color="fg.default"
          truncate
          flex={1}
        >
          {displayText}
        </Text>
      </HStack>

      {isSelected ? (
        <Tick01Icon
          size={13}
          style={{ flexShrink: 0, color: 'var(--colors-green-9)' }}
        />
      ) : null}
    </HStack>
  );
}
